<router-outlet></router-outlet>
<app-dialog-spinner *ngIf="_loaderService.displayNextClickSpinner"></app-dialog-spinner>
